import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          npm_package_version: {process.env.REACT_APP_VERSION}
        </p>
        <p>
          CF_PAGES_COMMIT_SHA: {process.env.REACT_APP_COMMIT_SHA}
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
